export enum LicenseCategory {
    ISP = "ISP",
    ENTERPRISE = "ENTERPRISE"
};

export interface featureItem {
    featureName: string;
    isAvailable: boolean;
    isStarAdded: boolean;
};

export enum LicensePack {
    "ISP-MO-100LP" = "ISP-MO-100LP",
    "ISP-MO-200LP" = "ISP-MO-200LP",
    "ISP-MO-300LP" = "ISP-MO-300LP",
    "ISP-MO-400LP" = "ISP-MO-400LP",
    "ISP-MO-500LP" = "ISP-MO-500LP",
    "ISP-MO-1KLP" = "ISP-MO-1KLP",
    "ISP-MO-2KLP" = "ISP-MO-2KLP",
    "ISP-MO-3KLP" = "ISP-MO-3KLP",
    "ISP-MO-4KLP" = "ISP-MO-4KLP",
    "ISP-MO-5KLP" = "ISP-MO-5KLP",
    "ISP-MO-6KLP" = "ISP-MO-6KLP",
    "ISP-MO-7KLP" = "ISP-MO-7KLP",
    "ISP-MO-8KLP" = "ISP-MO-8KLP",
    "ISP-MO-9KLP" = "ISP-MO-9KLP",
    "ISP-MO-10KLP" = "ISP-MO-10KLP",
    "ISP-MO-11KLP" = "ISP-MO-11KLP",
    "ISP-MO-12KLP" = "ISP-MO-12KLP",
    "ISP-MO-13KLP" = "ISP-MO-13KLP",
    "ISP-MO-14KLP" = "ISP-MO-14KLP",
    "ISP-MO-15KLP" = "ISP-MO-15KLP",
    "ISP-MO-16KLP" = "ISP-MO-16KLP",
    "ISP-MO-17KLP" = "ISP-MO-17KLP",
    "ISP-MO-18KLP" = "ISP-MO-18KLP",
    "ISP-MO-19KLP" = "ISP-MO-19KLP",
    "ISP-MO-20KLP" = "ISP-MO-20KLP",
    "ISP-MO-21KLP" = "ISP-MO-21KLP",
    "ISP-MO-22KLP" = "ISP-MO-22KLP",
    "ISP-MO-23KLP" = "ISP-MO-23KLP",
    "ISP-MO-24KLP" = "ISP-MO-24KLP",
    "ISP-MO-25KLP" = "ISP-MO-25KLP",
    "ISP-MO-30KLP" = "ISP-MO-30KLP",
    "ISP-MO-40KLP" = "ISP-MO-40KLP",
    "ISP-MO-50KLP" = "ISP-MO-50KLP",
    "TRIAL-MO-5LP" = "TRIAL-MO-5LP"
};

export enum TenantTypeName {
    ISP = "Standard",
    ISP_PLUS = "Plus",
    ISP_PRO = "Pro",
    ISP_TRIAL = "Trial"
}

export interface ISPSubscriptionPlan {
    planName: TenantTypeName;
    description: string;
    cycleSubDescription: string;
    extraFee?: number;
    extraFeePerMonth?: number;
    pricePrefix: string;
    cycleType: "/ month" | "/ year";
    features: featureItem[];
    buttonText: string;
    isPopular?: boolean;
    licensePackPrice: { [key in LicensePack]?: number }
};

export enum PaymentMethodEnum {
    SAVED = "SAVED",
    NEW = "NEW"
};

export enum SubscriptionPageControl {
    MANAGEMENT = "MANAGEMENT",
    UPGRADE_PLAN = "UPGRADE_PLAN"
};